import { useFeatureGate } from '@trello/feature-gate-client';

/**
 * Checks if Quick Capture inbox notifications are enabled.
 *
 * Requires both:
 * - ghost_qc_inbox_notifications: Main feature gate
 * - ghost_qc_inbox_notifications_prerequisites: Client-specific gate for version checks
 *
 * The prerequisites gate exists because the main gate spans web and server,
 * and cannot check client version numbers on the server.
 *
 * @returns {Object} An object with:
 *   - value: true if prerequisites and main feature are enabled
 *   - withQuery: true if prerequisites, main feature, and query gate are all enabled
 */
export const useIsQuickCaptureInboxNotificationsEnabled = () => {
  const { value: isQuickCaptureInboxNotificationsEnabled } = useFeatureGate(
    'ghost_qc_inbox_notifications',
  );
  const { value: isQuickCaptureInboxNotificationsPreRequisitesEnabled } =
    useFeatureGate('ghost_qc_inbox_notifications_prerequisites');
  const { value: isQuickCaptureNotificationQueryEnabled } = useFeatureGate(
    'ghost_notification_quick_capture_query',
  );

  const baseValue =
    isQuickCaptureInboxNotificationsPreRequisitesEnabled &&
    isQuickCaptureInboxNotificationsEnabled;

  return {
    value: baseValue,
    withQuery: baseValue && isQuickCaptureNotificationQueryEnabled,
  };
};
